import { Autocomplete, Box, Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { ApiDownloadExcel, ApiGetVenueList, ApiRegionVenues, ApiSiteSummary } from '../../apiService/Core/Apicall'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { Images } from '../../global/GloblImages'
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice'
import { RootState } from '../../global/config/store'
import { Info, InfoOutline } from '@mui/icons-material'
import storage from '../../utils/storage'

function SiteSummary() {
    const [sitesummary, setsitesummary] = useState<any>([])
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [venues, setvenues] = useState<number | string>(venuelist && (venuelist[0]?.venueId ?? ''))
    const [months, setmonths] = useState<number | string>(3)
    const { DownArrow, UpArrow } = Images()
    const Regions = useSelector(RegionList) || []
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const dispatch = useDispatch()
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
      const lastPayloadRef = useRef<Record<string, string>>({});
    
      const shouldSkip = (key: string, payload: string) => {
        if (lastPayloadRef.current[key] === payload) return true;
        lastPayloadRef.current[key] = payload;
        return false;
      };



    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0 && !selectedRegion) {
            setselectedRegion(Regions[0].regionId);
            setvenuelist(Regions[0].venues)
            setvenues(Regions[0].venues[0].venueId)
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    if (shouldSkip('VenueList', clientEntityId)) return;
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);
                    if (response.data.length > 0) {
                        setvenues(response.data[0].venueId)
                    }
                } catch (error: any) {
                    // toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
                if (finalregion && finalregion.length > 0) {
                    setvenues(finalregion[0].venueId)
                }

            }

        };
       clientEntity && Venuelist();

    }, [clientEntity,Regions, isGroupScore])

    useEffect(() => {
        const sitesummary = async () => {
            if (venues && months) {
                try {
                    const data = {
                        month: months && months,
                        venueId: venues && venues,
                        clientEntityId: isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')

                    }
                    const response = await ApiSiteSummary(data)
                    setsitesummary(response.data)
                } catch (error: any) {
                    // toast.error(error)
                }
                finally {
                }
            }

        }
        setTimeout(() => {
            sitesummary()
            
        }, 100);
    }, [venues, months, isGroupScore])


    const handledownloadExcel = async () => {
        try {
            const query = `?reportType=siteSummary&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem(
                "clientEntityId"
            )}&month=${months}&venueId=${venues}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `SiteSummary_${months}.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };

    return (
        <Box className='mt-3'>
            <Box maxWidth='100%' display={{ xs: "flex", md: "none" }} className='justify-content-end select-range white-select align-items-center gap-5'>
                {window.location.hostname.includes('aldi') && (
                    <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                        <InputLabel id="demo-simple-select-label" shrink={false}>Region: &nbsp;</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={Regions[0]?.regionId}
                            value={selectedRegion}
                            onChange={(e) => { setselectedRegion(e.target.value) }}
                        >
                            {Regions?.map((item: any, index: number) => (
                                <MenuItem key={index} value={item.regionId}>
                                    {item.regionName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                    <InputLabel id="demo-simple-select-label" shrink={false}>Sites:</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={venues}
                        onChange={(e) => { setvenues(e.target.value) }}
                    >
                        {venuelist?.map((item: any, index: number) => (
                            <MenuItem key={index} value={item.venueId}>
                                {item.venueName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {/* <FormControl>
                    <InputLabel id="demo-simple-select-label" shrink={false}>Months:</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={months}
                        onChange={(e) => { setmonths(e.target.value) }}
                    >
                        <MenuItem value={3} selected>3 Months</MenuItem>
                        <MenuItem value={6}>6 Months</MenuItem>
                        <MenuItem value={12}>12 Months</MenuItem>
                    </Select>
                </FormControl> */}
            </Box>
            {/* ---------------------------------------------- Top Bar ------------------------------------ */}
            <Box mt={{ xs: 2, md: 3 }} className='d-flex flex-warp-reverse align-items-center  justify-content-between'>
                <Typography className='fw-bold' variant='h5'>Site Overview</Typography>
                {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => setisGroupScore(e.target.checked)}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>
                )}
                <Box display={{ xs: "none", md: 'flex' }} className='pe-3 justify-content-between align-items-center' gap={{ xs: 5, lg: 2 }}>
                    <Button className='btn-main px-3' onClick={() => { handledownloadExcel() }}>Download Excel</Button>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ''}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        variant="outlined"
                                        sx={{ input: { color: 'black' } }} // Ensures text is visible
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        </FormControl>
                    )}
                    <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                        <Autocomplete
                            className='text-dark'
                            options={venuelist || []}
                            getOptionLabel={(option) => option.venueName || ''}
                            value={venuelist?.find((item) => item.venueId === venues) || null}
                            onChange={(event, newValue) => {
                                setvenues(newValue?.venueId || '');
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Sites" sx={{ color: 'black !important' }} variant="outlined" />
                            )}

                            isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                        />
                    </FormControl>
                    <FormControl sx={{ minWidth: { lg: "300px" } }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Months:</InputLabel> */}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={months}
                            // label="Months"
                            onChange={(e) => { setmonths(e.target.value) }}
                        >
                            <MenuItem value={3} selected>3 Months</MenuItem>
                            <MenuItem value={6}>6 Months</MenuItem>
                            <MenuItem value={12}>12 Months</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Box display={{ xs: "flex", md: 'none' }}>
                    <FormControl>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Months:</InputLabel> */}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={months}
                            onChange={(e) => { setmonths(e.target.value) }}
                        >
                            <MenuItem value={3} selected>3 Months</MenuItem>
                            <MenuItem value={6}>6 Months</MenuItem>
                            <MenuItem value={12}>12 Months</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

            </Box>

            {/* ---------------------------------------------- Middle Bar ------------------------------------ */}
            <Box gap={{ xs: 1, md: 1 }} mt={{ xs: 2, md: 3 }} className='d-flex flex-wrap' alignItems={'stretch'}>
                <Box width={{ xs: '48%', md: '19%' }} position='relative' className='h-100 bg-main border border-20 p-3  d-flex flex-column gap-5 align-items-start justify-content-between'>
                    <Typography className='txt-white' width={{ xs: '70%', md: '40%' }}>{months} Months Average</Typography>
                    <Typography className='fw-bold txt-white' fontSize={{ xs: "28px", md: "32px" }}>{parseFloat(sitesummary.averageScore) ? parseFloat(sitesummary.averageScore).toFixed(2) + '%' : 'N/A'}</Typography>
                </Box>
                <Box width={{ xs: '48%', md: '19%' }} position='relative' className='h-100 bg-secondary border border-20 p-3 d-flex flex-column gap-5 align-items-start justify-content-between'>
                    <Typography width={{ xs: '70%', md: "45%" }}> Last Time Score</Typography>
                    <Typography className='fw-bold ' fontSize={{ xs: "28px", md: "32px" }}>{parseFloat(sitesummary.lastMonthAverageScore) ? parseFloat(sitesummary.lastMonthAverageScore).toFixed(2) + '%' : sitesummary.previousMonthAverageScore}</Typography>
                </Box>
                <Box width={{ xs: '48%', md: '19%' }} position='relative' className='h-100 border border-20 p-3 d-flex gap-5 flex-column align-items-start justify-content-between'>
                    <Typography className='mb-4'>Lowest</Typography>
                    <Typography className='fw-bold text-secondary' fontSize={{ xs: "24px", md: "32px" }}>{(sitesummary.lowestMonth?.month &&
                        new Date(`${sitesummary.lowestMonth?.month.split('-')[1]}-${sitesummary.lowestMonth?.month.split('-')[0]}-01`)
                            .toLocaleString('default', { month: 'long' })) ?? 'N/A'}</Typography>
                    <Box component='img' width='20%' maxWidth='50px' className='down-img' src={DownArrow}></Box>
                </Box>
                <Box width={{ xs: '48%', md: '19%' }} position='relative' className='h-100 border border-20 p-3 d-flex gap-5 flex-column align-items-start justify-content-between'>
                    <Typography className='mb-4'>Highest</Typography>
                    <Typography className='fw-bold text-third' fontSize={{ xs: "24px", md: "32px" }}>{(sitesummary.highestMonth?.month &&
                        new Date(`${sitesummary.highestMonth?.month.split('-')[1]}-${sitesummary.highestMonth?.month.split('-')[0]}-01`)
                            .toLocaleString('default', { month: 'long' })) ?? 'N/A'}</Typography>
                    <Box component='img' width='15%' className='down-img' src={UpArrow}></Box>
                </Box>
                <Box width={{ xs: '48%', md: '19%' }} position='relative' className='h-100 border border-20 p-3 d-flex gap-5 flex-column align-items-start justify-content-between'>
                    <Box className='d-flex align-items-center gap-2'>
                        <Typography>Change</Typography>
                        <Tooltip title='Change is the difference between the lowest month score and the highest month score'><InfoOutline sx={{ fontSize: "16px" }} /></Tooltip>
                    </Box>
                    <Typography className='fw-bolder text-main mt-4' fontSize={{ xs: "28px", md: "32px" }}>{(sitesummary?.changeBetweenHighLow) ?? 'N/A'}%</Typography>
                </Box>
            </Box>

            {/* ---------------------------------------------- Main Content ------------------------------------ */}
            {/* <Box className='mt-4 bg-light-main d-flex flex-wrap gap-2 p-3 border-20'>
                {sitesummary && (sitesummary?.monthlyScores)?.length > 0 ? (sitesummary?.monthlyScores.map((item: any, index: number) => {
                    const date = new Date(item?.month);
                    const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
                    const formattedDay = `${weekday}`;
                    const formattedMonthYear = ` ${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

                    return (
                        <Box key={index} width={{ xs: "100%", md: '49%' }} className='d-flex  align-items-center justify-content-between mb-3 gap-2'>
                            <Box width='8%' mr={2}>
                                <Typography fontSize='14px' className='text-main'>{formattedDay}</Typography>
                                <Typography fontSize='14px' width='12%'>{formattedMonthYear}</Typography>
                            </Box>
                            <Box className='d-flex gap-2' width={{ xs: '75%', md: '100%' }}>
                                <div className="custom-progress-bar">
                                    <div className="progress-fill" style={{ width: `${item?.averageScore}%` }}></div>
                                </div>
                                <Typography fontWeight={900}>{item?.averageScore}%</Typography>
                            </Box>

                        </Box>
                    );
                })) : (<Typography className='mx-auto text-center my-5' variant='h5'>No Data Found</Typography>)}

            </Box> */}
            <Box
                className="mt-4 bg-light-main p-3 border-20"
                sx={{
                    display: "grid",
                    gridAutoFlow: "column", // fills down first, then goes to the next column
                    gridAutoRows: "auto",
                    gridTemplateRows: "repeat(6, auto)", // max 6 rows
                    gap: 2,
                }}
            >
                {sitesummary && (sitesummary?.monthlyScores)?.length > 0 ? (
                    sitesummary?.monthlyScores
                        .sort((a: any, b: any) => new Date(b.month).getTime() - new Date(a.month).getTime())
                        .map((item: any, index: number) => {
                            const date = new Date(item?.month);
                            const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
                            const formattedDay = `${weekday}`;
                            const formattedMonthYear = ` ${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

                            return (
                                <Box
                                    key={index}
                                    className="d-flex align-items-center  justify-content-between gap-2"
                                    sx={{
                                        mb: 2,
                                        maxWidth: sitesummary?.monthlyScores.length <= 6 ? "49%" : 'auto'
                                    }}
                                >
                                    <Box width="8%" mr={2}>
                                        <Typography fontSize="14px" className="text-main">
                                            {formattedDay}
                                        </Typography>
                                        <Typography fontSize="14px">{formattedMonthYear}</Typography>
                                    </Box>
                                    <Box className="d-flex gap-2" width="100%">
                                        <div className="custom-progress-bar">
                                            <div
                                                className="progress-fill"
                                                style={{ width: `${item?.averageScore}%` }}
                                            ></div>
                                        </div>
                                        <Typography fontWeight={900}>{item?.averageScore}%</Typography>
                                    </Box>
                                </Box>
                            );
                        })
                ) : (
                    <Typography className="mx-auto text-center my-5" variant="h5">
                        No Data Found
                    </Typography>
                )}
            </Box>

        </Box>
    )
}

export default SiteSummary
